<template>
  <div class="panel panel-gray wraper">
    <div class="panel-header compact" id="list-header">
      <q-btn-toggle
          v-model="filter"
          color="white"
          no-caps
          :dense="$route.name!=='cases'"
          text-color="primary"
          toggle-color="primary"
          :options="[
                  {label: 'Все', value: 'all'},
                  {icon: 'photo_camera', value: 'image'},
                  {icon: 'videocam', value: 'video'},
                  {icon: 'mic', value: 'audio'},
                  {icon: 'insert_drive_file', value: 'application'},
                  {icon: 'delete', value: 'unlinked'}
                ]"
      />
      <q-input
          name="nameFilter"
          v-model="nameFilter"
          float-label="&#128269; в названии"
          clearable
          class="q-ml-md"
          style="max-width: 400px; margin-top: -10px;"
          :disabled="filter === 'unlinked'"
      />
    </div>
    <div class="row group" :class="{scroll: $route.meta.showLeft}">
      <galery-item
          v-for="(item) in visibleMedias"
          :item="item"
          :key="item.key"
          :view="viewMedia"
          :goEdit="goEdit"
      />
      <my-scroll :handler="getMore" ref="myscroll">
        <q-spinner-dots :size="40" />
      </my-scroll>
      <q-btn
          v-back-to-top.animate="500"
          round
          color="teal-5"
          class="fixed-bottom-left"
          style="margin: 0 0 15px 15px"
      >
        <q-icon name="keyboard_arrow_up" />
      </q-btn>
    </div>
    <q-modal v-model="audio" content-css="background-color: transparent; box-shadow: none;" minimized @show="play">
      <audio id="a" v-if="audioUrl" :src="audioUrl" controls />
    </q-modal>
    <slim-cropper :options="slimOptions" ref="slim" :data="blob" v-if="mode === 'slim'"/>
    <q-modal v-model="resizemode" maximized content-classes="panel mediator">
        <div class="panel-header">
          <q-btn @click="didCancel" title="Закрыть" color="primary" icon="clear" small round flat />
          <q-btn
              @click="doSave"
              :disabled="!blob"
              color="positive"
              icon="done"
              small
              round
              flat
              title="Сохранить"
          />
        </div>
        <div class="panel-body">
          <pic-resize
              v-if="mode === 'resize'"
              v-model="blob"
              :maxHeight=picMaxHeight
              :url="picUrl"
              :picIniSize="picIniSize"
              :editableFormat="editableFormat"
              :maxQuality="101"
          />
        </div>
    </q-modal>
  </div>
</template>
<script type="text/babel">
import MyScroll from 'components/my-scroll.vue';
import GaleryItem from 'components/galery-item';
import { ActionSheet, Loading } from 'quasar';
import SlimCropper from 'components/slim.vue';
import PicResize from 'components/pic-resize.vue';
import _ from 'lodash';

const statusLabel = {
  image: 'Картинки',
  video: 'Видео',
  audio: 'Аудио',
  application: 'Документы',
  unlinked: 'Корзина',
  all: 'Все',
};

export default {
  name: 'mediaslazy',
  components: {
    MyScroll, GaleryItem, SlimCropper, PicResize,
  },
  mounted() {
    this.loadAllMedias();
    console.log('sockets', this.$options.sockets);
    this.$options.sockets.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('------------', data);
      if (data.event === 'THUMB') {
        this.refresh(data.id);
      } else if (data.event === 'DELETED_MEDIA') {
        const ind = this.allMedias.findIndex(item => item.key === data.id);
        if (ind > -1) this.allMedias.splice(ind, 1);
      }
    };
  },
  beforeDestroy() {
    delete this.$options.sockets.onmessage;
  },
  data() {
    return {
      nameFilter: '',
      limit: 10,
      allMedias: [],
      audioUrl: '',
      editableFormat: null,
      picUrl: '',
      picIniSize: 0,
      mode: '',
      blob: null,
      editedKey: '',
      slimOptions: {
        instantEdit: true,
        push: true,
        didCancel: this.didCancel,
        service: this.slimService,
        serviceFormat: 'file',
        buttonConfirmLabel: 'Сохранить',
        buttonCancelLabel: 'Отменить',
        buttonConfirmTitle: 'Сохранить',
        buttonCancelTitle: 'Отменить',
        buttonRotateTitle: 'Повернуть',
      },
    };
  },
  watch: {
    filter: {
      handler: 'handle',
    },
    nameFilter: {
      handler: 'handle',
    },
  },
  computed: {
    picMaxHeight() {
      return (this.$store.state.pageHeight) - 110;
    },
    audio: {
      get() {
        return !!this.audioUrl;
      },
      set(v) {
        if (!v) this.audioUrl = '';
      },
    },
    resizemode: {
      get() {
        return this.mode === 'resize';
      },
      set(v) {
        if (!v) this.mode = '';
      },
    },
    filter: {
      get() {
        return this.$route.params.filter;
      },
      set(v) {
        this.$router.push(`/x/${v}`);
      },
    },
    filteredMedias() {
      return this.allMedias.filter((m) => {
        if (this.filter === 'unlinked') {
          if (m.value._linkcount === 0) {
            m.value.local = !!this.$store.state.offMedias[m.key];
            return true;
          }
        } else if (this.filter === 'all' || this.filter === m.value.contentType.split('/')[0]) {
          if (!this.nameFilter || (m.value.link && m.value.link.name && m.value.link.name.toLocaleLowerCase().includes(this.nameFilter))) {
            m.value.local = !!this.$store.state.offMedias[m.key];
            return true;
          }
        }
        return false;
      });
    },
    visibleMedias() {
      return this.filteredMedias.slice(0, this.limit);
    },
  },
  methods: {
    goEdit(media) {
      console.log('goEdit media', media);
      const it = this;
      const actions = [];
      if (media.value.contentType.split('/')[0] === 'image') {
        actions.push(
          {
            label: 'Сжать',
            color: 'primary',
            icon: 'photo_size_select_large',
            handler() {
              it.shrink(media);
            },
          },
          {
            label: 'Обрезать/повернуть',
            color: 'primary',
            icon: 'crop_rotate',
            handler() {
              it.cropRotate(media);
            },
          },
        );
      }
      if (media.value._linkcount === 0) {
        actions.push({
          label: 'Удалить навсегда',
          color: 'negative',
          icon: 'delete_forever',
          handler() {
            it.doDelete(media);
          },
        });
      }
      ActionSheet.create({
        title: 'Выберите действие',
        actions,
      })
        .catch(() => {
          console.log('canceled');
        });
    },
    didCancel() {
      console.log('didCancel');
      this.mode = '';
      Loading.hide();
    },
    refresh(id) {
      console.log('refresh id', id);
      const ind = this.allMedias.findIndex(item => item.key === id);
      console.log('refresh ind', ind);
      if (ind > -1) {
        this.$store.dispatch('loadMedias', id)
          .then((res) => {
            if (res[0]) { // refresh thumb
              this.allMedias.splice(ind, 1);
              this.$nextTick(() => {
                this.allMedias.splice(ind, 0, res[0]);
              });
            }
          })
          .catch((err) => {
            this.$store.commit('pushError', err);
          });
      }
    },
    doSave() {
      if (this.blob) {
        Loading.show();
        this.$store.dispatch('savePic', {
          id: this.editedKey,
          file: this.blob,
        })
          .then(() => {
            this.mode = '';
            Loading.hide();
          })
          .catch((err) => {
            this.$store.commit('pushError', err);
            this.mode = '';
            Loading.hide();
          });
      } else {
        console.log('********** picture not changed ************');
        this.mode = '';
      }
    },
    slimService(formdata, progress, success, failure, slim) {
      // slim instance reference
      console.log('rotation', slim._data.actions.rotation);
      console.log('input', slim._data.input.height, slim._data.input.width);
      console.log('output', slim._data.output.height, slim._data.output.width);
      // const win = window.open(URL.createObjectURL(formdata[0]), '_blank');
      const changed = () => {
        if (slim._data.actions.rotation > 0) return true;
        if (Math.abs(slim._data.input.height - slim._data.output.height) > 3) return true;
        if (Math.abs(slim._data.input.width - slim._data.output.width) > 3) return true;
        return false;
      };
      if (changed()) {
        this.$store.dispatch('savePic', {
          id: this.editedKey,
          file: formdata[0],
        })
          .then(() => {
            this.mode = '';
            Loading.hide();
          })
          .catch((err) => {
            this.$store.commit('pushError', err);
            this.mode = '';
            Loading.hide();
          });
      } else {
        console.log('********** picture not changed ************');
        this.mode = '';
        Loading.hide();
      }
    },
    cropRotate(media) {
      console.log('cropRotate media', media);
      Loading.show();
      this.loadMedia(media.key)
        .then(() => {
          this.editedKey = media.key;
          this.mode = 'slim';
        });
    },
    shrink(media) {
      console.log('shrink media', media);
      const f = media.value.contentType.split('/')[1];
      if (f === 'jpeg' || f === 'png' || f === 'bmp') {
        this.editableFormat = f;
      } else {
        this.editableFormat = null;
      }
      this.loadMedia(media.key)
        .then((url) => {
          this.picUrl = url;
          this.picIniSize = media.value.size;
          this.blob = null;
          this.editedKey = media.key;
          this.mode = 'resize';
        });
    },
    doDelete(media) {
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: 'Файл будет безвозвратно удален!',
        ok: {
          flat: true,
          color: 'negative',
          label: 'Удалить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => {
          this.opened = false;
          this.$store.dispatch('deleteFile', media.key)
            .then(() => {
              const ind = this.allMedias.findIndex(item => item.key === media.key);
              if (ind > -1) this.allMedias.splice(ind, 1);
            })
            .catch((err) => {
              this.$store.commit('pushError', {
                error: err.error || 'Ошибка!',
                message: err.message || 'Возможно удаление не произведено',
              });
            });
        })
        .catch(() => {
        });
    },
    play() {
      const a = document.getElementById('a');
      if (a) a.play();
    },
    loadMedia(id) {
      return this.$store.dispatch('getAttachment', id)
        .then((blob) => {
          this.blob = blob;
          return URL.createObjectURL(blob);
        })
        .catch((err) => {
          console.log('getAttachment error', err);
          if (err.status === 404) {
            this.$store.commit('pushError', {
              error: 'Ошибка',
              message: 'Файл не найден',
              type: 'negative',
            });
          }
        });
    },
    viewMedia(item) {
      Loading.show();
      this.loadMedia(item.key)
        .then((mediaUrl) => {
          Loading.hide();
          if (item.value.contentType.split('/')[0] === 'audio') {
            this.audioUrl = mediaUrl;
          } else {
            const win = window.open(mediaUrl, '_blank');
            win.onload = function () {
              win.document.title = item.value.link.name || '[В корзине]';
            };
            win.focus();
          }
        });
    },
    handle: _.debounce(function () {
      console.log('debounce');
      this.limit = 10;
      this.audioUrl = '';
      if (this.filter) {
        if (this.filter === 'unlinked') {
          this.nameFilter = '';
        } else {
          this.nameFilter = this.nameFilter.toLocaleLowerCase();
        }
        if (statusLabel[this.filter]) {
          document.title = `Файлы - ${statusLabel[this.filter]}`;
        } else {
          this.$router.push('/x/all');
        }
      }
      if (this.filteredMedias.length > 0) {
        this.$store.commit('pushError', {
          error: statusLabel[this.filter],
          message: `Всего найдено ${this.filteredMedias.length}`,
          type: 'positive',
        });
      } else {
        this.$store.commit('pushError', {
          error: statusLabel[this.filter],
          message: 'Ничего не найдено',
          type: 'warning',
        });
      }
      if (this.$refs.myscroll) this.$refs.myscroll.init();
    }, 1000),
    loadAllMedias() {
      return this.$store.dispatch('loadMedias')
        .then((res) => {
          console.log('loadAllMedias', res.length);
          this.allMedias = res;
          this.handle();
        })
        .catch(err => Promise.reject(err));
    },
    getMore() {
      if (this.limit < this.filteredMedias.length) {
        this.limit = Math.min(this.limit + 10, this.filteredMedias.length);
        return Promise.resolve(true);
      }
      return Promise.resolve(false);
    },
  },
};
</script>
<style scoped lang="stylus">
  @import '~variables'
  .q-checkbox
    margin-left 20px
  #list-header
    justify-content flex-start
    color $primary
    .q-btn-group
      box-shadow none
</style>



// WEBPACK FOOTER //
// src/pages/medias-lazy.vue